import { useMutation, UseMutationOptions, useQueryClient } from '@tanstack/react-query';
import api from '../../api';
import { PaymentMethod } from '@/types/stores/global';
import useGlobalStore from '@/stores/global.store';

type TData = { paymentId?: string };
type TVariables = { orderId: string; paymentMethod: PaymentMethod };

export function usePlaceOrderMutation(options?: UseMutationOptions<TData, Error, TVariables>) {
  const pay = useGlobalStore((state) => state.pay);
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['place-order'],
    mutationFn: ({ orderId, paymentMethod }: TVariables) => api.order.place(orderId, paymentMethod),
    onSuccess: async (data) => {
      // If there's no payment to track (e.g. Pay Later), usePollOrderConfirmation picks up
      // the order's new status straight from this invalidation — no separate signal needed.
      if (data.paymentId) {
        pay(data.paymentId);
      }

      queryClient.invalidateQueries({
        queryKey: ['orders'],
      });
    },
    ...options,
  });
}
